import { getUserInfo } from "@actions/profile.js";
import {
	getActiveWithdrawMethods,
	getDocumentStatus,
	getOdendibilTypes,
	withdraw,
} from "@actions/withdraw.js";
import { showAlert } from "@components/alert/action";
import Loading from "@components/loading/index.jsx";
import enums from "@enums";
import { useVerification } from "@layouts/v4/verificationPopup/index.js";
import ArrowRight from "@pages/profile-v2/assets/icons/ArrowRight.jsx";
import {
	GRID_WRAPPER,
	Icon,
	ImgWrapper,
	MinMaxWrapper,
	MinOrMax,
	Text,
	Value,
	WithdrawButton,
	WithdrawContentWrapper,
	WithdrawItem,
	WithdrawLogoWrapper,
	WithdrawMinMax,
	WithdrawNameDesktop,
	WithdrawNameFeaturesWrapper,
	WithdrawNameMobile,
	WithdrawNameWrapper,
	WithdrawValueWrapper,
} from "@pages/profile-v2/pages/withdraw/baseItems.js";
import APay from "@pages/profile-v2/pages/withdraw/paymentMethods/apay";
import BetterBro from "@pages/profile-v2/pages/withdraw/paymentMethods/betterBro";
import CoinsPaid from "@pages/profile-v2/pages/withdraw/paymentMethods/coinspaid";
import Monetix from "@pages/profile-v2/pages/withdraw/paymentMethods/monetix.js";
import { MonetixPagamigos } from "@pages/profile-v2/pages/withdraw/paymentMethods/pagamigos";
import Piastrix from "@pages/profile-v2/pages/withdraw/paymentMethods/piastrix";
import Skrill from "@pages/profile-v2/pages/withdraw/paymentMethods/skrill";
import Unlimit from "@pages/profile-v2/pages/withdraw/paymentMethods/unlimit";
import Vpag from "@pages/profile-v2/pages/withdraw/paymentMethods/vpag";
import { formatMoney } from "@pages/profile-v2/utils/index.js";
import SubPage from "@pages/profile/subPage.jsx";
import Form from "antd/lib/form";
import React, { Fragment } from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import * as logos from "../../assets/paymentLogos/onwhite/index";
import AnindaMFT from "./paymentMethods/anindaMFT.js";
import BankTransfer from "./paymentMethods/bankTransfer.js";
import Centralpay from "./paymentMethods/centralpay.js";
import Crypto from "./paymentMethods/crypto.js";
import CryptoPayment from "./paymentMethods/cryptopayment.js";
import Fixturka from "./paymentMethods/fixturka.js";
import FxCuzdan from "./paymentMethods/fxcuzdan.js";
import Mefete from "./paymentMethods/mefete.js";
import NuveiSTP from "./paymentMethods/nuveiSTP";
import NuveiSpei from "./paymentMethods/nuveiSpei";
import Odendibil from "./paymentMethods/odendibil.js";
import Papara from "./paymentMethods/papara.js";
import PaparaFast from "./paymentMethods/paparaFast.js";
import Payco from "./paymentMethods/payco.js";
import Payturka from "./paymentMethods/payturka.js";
import SapphirePapara from "./paymentMethods/sapphirepapara.js";
import SendToFriend from "./paymentMethods/sendToFriend.js";
import STP from "./paymentMethods/stp";
import TrendHavale from "./paymentMethods/trendhavale.js";
import TurboHavale from "./paymentMethods/turbohavale.js";
import TurboYatirim from "./paymentMethods/turboyatirim.js";
import UnifyPay from "./paymentMethods/unifyPay.js";
import Vevopay from "./paymentMethods/vevopay.js";
import VevopayPopyPara from "./paymentMethods/vevopayPopyPara.js";

export class Withdraw extends SubPage {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			currentPage: 1,
			hoverItem: "",
			selectedWithdraw: {},
		};
		this.wrappedWithdraw = this.wrappedWithdraw.bind(this);
	}

	wrappedWithdraw(data, cb) {
		const { withdraw, withVerification, showAlert } = this.props;

		if (!withVerification) {
			return withdraw(data, cb);
		}

		const withdrawPromise = (params) =>
			new Promise((resolve, reject) => {
				withdraw(params, (response) => {
					if (response && response.error) {
						reject(response);
					} else {
						resolve(response);
					}
				});
			});

		withVerification(withdrawPromise, data)
			.then(() => {
				cb(response);

				if (window.SUMSUB_VERIFICATION_INTERCEPTOR) {
					dispatch({
						type: enums.ALERT_IN,
						payload: {
							type: "success",
							msg: "SUCCESSFULL_WITHDRAW",
							title: "SUCCESSFULL_TITLE",
						},
					});
				}
			})
			.catch((error) => {
				if (error.message && error.message.includes("verification.closed")) {
					return;
				}

				if (error.message && error.message.includes("verification")) {
					showAlert({
						type: "error",
						msg: error.message,
						title: "ERROR",
					});
				}

				if (cb) cb(error);
			});
	}

	async componentDidMount() {
		this.setState({ ...this.state, showHeader: false, showSidebar: false });
		this.props.getUserInfo();
		this.props.getDocumentStatus({ params: { cameFrom: "Withdraw" } }, () => {
			this.props.getActiveWithdrawMethods();
		});
	}

	getPageHeader(t) {
		return t("WITHDRAW");
	}

	onBackToWithdrawPage = () => {
		this.setState({
			currentPage: 1,
		});
	};

	onSelectWithdraw = (item) => {
		this.setState({
			currentPage: 2,
			selectedWithdraw: item,
		});
	};

	getCurrencyIcon(code) {
		if (code == "EUR") {
			return String.fromCharCode(8364);
		} else if (code == "TRY") {
			return String.fromCharCode(8378);
		} else {
			return;
		}
	}

	getCurrencyOfMethod(currencies) {
		const { wallet } = this.props;
		let currencyNeedShowing = currencies.find(
			(element) => element.currency === wallet.total?.currency
		);
		if (currencyNeedShowing) {
			return currencyNeedShowing;
		} else {
			return currencies[0] ? currencies[0] : null;
		}
	}

	getMethodLogo(method) {
		if (
			method.indexOf("Skrill") > -1 ||
			method.indexOf("APay") > -1 ||
			method.indexOf("Monetix") > -1 ||
			method.indexOf("Vpag") > -1 ||
			method.indexOf("STP") > -1 ||
			method.indexOf("Unlimit") > -1 ||
			method.indexOf("BetterBro") > -1
		) {
			return logos[method];
		}
		if (method.indexOf("CoinsPaid") > -1) {
			return logos[method.replace("-", "")];
		}
		switch (method) {
			case "MonetixPagamigos":
				return logos["MonetixPagamigos"];
			case "Vcreditos":
				return logos["Vcreditos"];
			case "BetterBroPix":
				return logos["BetterBroPix"];
			case "BetterBro SPEI":
				return logos["BetterBroSPEI"];
			case "Piastrix":
				return logos["Piastrix"];
			case "Centralpay":
				return logos["payfix"];
			case "Payturka":
				return logos["payfix"];
			case "Payfix":
				return logos["payfix"];
			case "APayPIX":
				return logos["APayPIX"];
			case "MFT":
				return logos["mft"];
			case "CryptoPay":
				return logos["cryptopay"];
			case "BTC MARS Cryptopayment":
				return logos["cryBtc"];
			case "ETH MARS Cryptopayment":
				return logos["cryEth"];
			case "TRX MARS Cryptopayment":
				return logos["cryTron"];
			case "USDT.TRC20 MARS Cryptopayment":
				return logos["cryUsdt"];
			case "BTC ZENGİNSİN Cryptopayment":
				return logos["cryBtc"];
			case "ETH ZENGİNSİN Cryptopayment":
				return logos["cryEth"];
			case "TRX ZENGİNSİN Cryptopayment":
				return logos["cryTron"];
			case "USDT.TRC20 ZENGİNSİN Cryptopayment":
				return logos["cryUsdt"];
			case "BTC CHOKWIN Cryptopayment":
				return logos["cryBtc"];
			case "ETH CHOKWIN Cryptopayment":
				return logos["cryEth"];
			case "TRX CHOKWIN Cryptopayment":
				return logos["cryTron"];
			case "USDT.TRC20 CHOKWIN Cryptopayment":
				return logos["cryUsdt"];
			case "PEP":
				return logos["pep"];
			case "QR":
				return logos["qr"];
			case "ATM Kartsız Çekim":
				return logos["pep"];
			case "ATM Cardless Withdrawal":
				return logos["atmkartsizEn"];
			case "Papara":
				return logos["papara"];
			case "SendToFriend":
				return logos["sendtofriendEn"];
			case "Arkadaşına Gönder":
				return logos["sendtofriendTr"];
			case "Papara Fast":
				return logos["paparafastEn"];
			case "Papara Hızlı":
				return logos["paparafastTr"];
			case "Vevopay":
				return logos["vevopay"];
			case "VevopayPopy":
				return logos["vevopayPopyPara"];
			case "TurboYatirim":
				return logos["paybol"];
			case "TurboHavale":
				return logos["turbohavale"];
			case "FxCuzdan":
				return logos["fxcuzdan"];
			case "Payco":
				return logos["payco"];
			case "CentralPay":
				return logos["vevopay"];
			case "Safir Papara":
				return logos["sapphirepapara"];
			case "AnindaMFT":
				return logos["anindamft"];
			case "TrendHavale":
				return logos["trend"];
			case "NuveiSTP":
				return logos["NuveiSTP"];
			case "NuveiSpei":
				return logos["NuveiSTP"];
			default:
				if (method.indexOf("88Pay") > -1) return logos["ipay88"];
				return null;
		}
	}

	formatWithdrawName(name, method) {
		if (!name && !method) return "";

		if ((name === "BetterBroPix" || method === "BetterBroPix") && window.TENANT === "mars-br") {
			return "Pix";
		}

		const textToFormat = name || method;
		return textToFormat
			.split(" ")
			.map((word) =>
				/^[A-Z]+$/.test(word) ? word : word.replace(/([A-Z](?=[a-z]))/g, " $1").trim()
			)
			.join(" ");
	}

	renderSelectedWithdraw() {
		const { selectedWithdraw } = this.state;
		const { showAlert, user, wallet, languages } = this.props;
		const { method } = selectedWithdraw;
		if (method === "MFT") {
			return (
				<Mefete
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method.indexOf("Monetix") > -1) {
			return (
				<Monetix
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					method={method}
					languages={languages}
				/>
			);
		} else if (method.indexOf("APay") > -1) {
			return (
				<APay
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					method={method}
					languages={languages}
				/>
			);
		} else if (method.indexOf("Unlimit") > -1) {
			return (
				<Unlimit
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					method={method}
					languages={languages}
				/>
			);
		} else if (method.indexOf("Vpag") > -1 || method.indexOf("Vcreditos") > -1) {
			return (
				<Vpag
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					method={method}
					languages={languages}
				/>
			);
		} else if (method.indexOf("CoinsPaid") > -1) {
			return (
				<CoinsPaid
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					method={method}
					languages={languages}
				/>
			);
		} else if (method === "Piastrix") {
			return (
				<Piastrix
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "STP") {
			return (
				<STP
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method.indexOf("BetterBro") > -1) {
			return (
				<BetterBro
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					method={method}
					languages={languages}
				/>
			);
		} else if (method.indexOf("Skrill") > -1) {
			return (
				<Skrill
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					method={method}
					languages={languages}
				/>
			);
		} else if (method === "CryptoPay") {
			return (
				<Crypto
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "MonetixPagamigos") {
			return (
				<MonetixPagamigos
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (
			method === "BTC ZENGİNSİN Cryptopayment" ||
			method === "ETH ZENGİNSİN Cryptopayment" ||
			method === "TRX ZENGİNSİN Cryptopayment" ||
			method === "USDT.TRC20 ZENGİNSİN Cryptopayment"
		) {
			return (
				<CryptoPayment
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					cryptoCurrency={selectedWithdraw.cryptoCurrency}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (
			method === "USDT.TRC20 MARS Cryptopayment" ||
			method === "TRX MARS Cryptopayment" ||
			method === "BTC MARS Cryptopayment" ||
			method === "ETH MARS Cryptopayment"
		) {
			return (
				<CryptoPayment
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					cryptoCurrency={selectedWithdraw.cryptoCurrency}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (
			method === "USDT.TRC20 CHOKWIN Cryptopayment" ||
			method === "TRX CHOKWIN Cryptopayment" ||
			method === "BTC CHOKWIN Cryptopayment" ||
			method === "ETH CHOKWIN Cryptopayment"
		) {
			return (
				<CryptoPayment
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					cryptoCurrency={selectedWithdraw.cryptoCurrency}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "Payturka") {
			return (
				<Payturka
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "Payfix") {
			return (
				<Fixturka
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "Payco") {
			return (
				<Payco
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "PEP") {
			return (
				<Odendibil
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					paymentMethod="pep"
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					getTypes={this.props.getOdendibilTypes}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "QR") {
			return (
				<Odendibil
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					paymentMethod="qr"
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					getTypes={this.props.getOdendibilTypes}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "ATM Kartsız Çekim" || method === "ATM Cardless Withdrawal") {
			return (
				<BankTransfer
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "SendToFriend" || method === "Arkadaşına Gönder") {
			return (
				<SendToFriend
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "Papara") {
			return (
				<Papara
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "Vevopay") {
			return (
				<Vevopay
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "VevopayPopy") {
			return (
				<VevopayPopyPara
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "TurboYatirim") {
			return (
				<TurboYatirim
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "TurboHavale") {
			return (
				<TurboHavale
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "FxCuzdan") {
			return (
				<FxCuzdan
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "Centralpay") {
			return (
				<Centralpay
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "TrendHavale") {
			return (
				<TrendHavale
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "SapphirePapara" || method === "Safir Papara") {
			return (
				<SapphirePapara
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "Papara Fast" || method === "Papara Hızlı") {
			return (
				<PaparaFast
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "AnindaMFT") {
			return (
				<AnindaMFT
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "NuveiSTP") {
			return (
				<NuveiSTP
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method === "NuveiSpei") {
			return (
				<NuveiSpei
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					languages={languages}
				/>
			);
		} else if (method.indexOf("88Pay") > -1) {
			return (
				<UnifyPay
					selectedWithdraw={selectedWithdraw}
					showAlert={showAlert}
					user={user}
					onBackToWithdrawPage={this.onBackToWithdrawPage.bind(this)}
					onWithdraw={this.wrappedWithdraw}
					wallet={wallet}
					method={method}
					languages={languages}
				/>
			);
		}
	}

	setHoverItem(hoverItem) {
		this.setState({ hoverItem });
	}

	sortMethods(a, b) {
		if (a.order < b.order) {
			return -1;
		}
		if (a.order > b.order) {
			return 1;
		}
		return 0;
	}

	create2ElementsFromOne(assignedElement, assigneeElement) {
		let assigned = assignedElement;
		assigned.canDeposit = assigneeElement.canDeposit;
		assigned.canWithdraw = assigneeElement.canWithdraw;
		assigned.currencies = assigneeElement.currencies;
		assigned.excludedCountries = assigneeElement.excludedCountries;
		assigned.isActive = assigneeElement.isActive;
		assigned.isCard = assigneeElement.isCard;
		assigned.minDepositCount = assigneeElement.minDepositCount;
		assigned.order = assigneeElement.order;
		assigned.tenant = assigneeElement.tenant;
		assigned.method = assigneeElement.method;
		return assigned;
	}

	getAllMethods(withdrawMethods) {
		let resultArray = [];
		const language = this.props.languages.find((i) => i.active == true);
		const languageCode = language.code;
		for (const element of withdrawMethods) {
			let payMethod = new Object();
			payMethod = this.create2ElementsFromOne(payMethod, element);
			const { method } = element;
			if (
				method.indexOf("Skrill") > -1 ||
				method.indexOf("APay") > -1 ||
				method === "MonetixPagamigos" ||
				method === "MonetixThailandBank" ||
				method === "Vevopay" ||
				method === "BetterBroChileBankTransfer" ||
				method === "BetterBroArgentinaCbuCvu" ||
				method === "BetterBroEcuadorBankTransferHPP"
			) {
				payMethod["logoCls"] = "no-filter";
			} else if (method === "EtoroCryptopayment-ETH") {
				payMethod["logoCls"] =
					window.IS_MARS || window.TENANT === "chokwin" ? "no-filter" : "";
				payMethod["method"] =
					window.TENANT === "chokwin"
						? "ETH CHOKWIN Cryptopayment"
						: window.IS_MARS
							? "ETH MARS Cryptopayment"
							: "ETH ZENGİNSİN Cryptopayment";
				payMethod["cryptoCurrency"] = "ETH";
			} else if (method === "BetterBroSPEI") {
				payMethod["method"] = "BetterBro SPEI";
			} else if (method === "EtoroCryptopayment-BTC") {
				payMethod["cryptoCurrency"] = "BTC";
				payMethod["logoCls"] =
					window.IS_MARS || window.TENANT === "chokwin" ? "no-filter" : "";
				payMethod["method"] =
					window.TENANT === "chokwin"
						? "BTC CHOKWIN Cryptopayment"
						: window.IS_MARS
							? "BTC MARS Cryptopayment"
							: "BTC ZENGİNSİN Cryptopayment";
			} else if (method === "EtoroCryptopayment-TRX") {
				payMethod["cryptoCurrency"] = "TRX";
				payMethod["logoCls"] =
					window.IS_MARS || window.TENANT === "chokwin" ? "no-filter" : "";
				payMethod["method"] =
					window.TENANT === "chokwin"
						? "TRX CHOKWIN Cryptopayment"
						: window.IS_MARS
							? "TRX MARS Cryptopayment"
							: "TRX ZENGİNSİN Cryptopayment";
			} else if (method === "EtoroCryptopayment-USDT") {
				payMethod["logoCls"] =
					window.IS_MARS || window.TENANT === "chokwin" ? "no-filter" : "";
				payMethod["cryptoCurrency"] = "USDT.TRC20";
				payMethod["method"] =
					window.TENANT === "chokwin"
						? "USDT.TRC20 CHOKWIN Cryptopayment"
						: window.IS_MARS
							? "USDT.TRC20 MARS Cryptopayment"
							: "USDT.TRC20 ZENGİNSİN Cryptopayment";
			} else if (method === "Odendibil-pep") {
				payMethod["method"] = "PEP";
			} else if (method === "Odendibil-qr") {
				payMethod["method"] = "QR";
			} else if (method === "SapphirePapara") {
				payMethod["method"] = "Safir Papara";
			} else if (method === "Fixturka") {
				payMethod["method"] = "Payfix";
			} else if (method === "Payco") {
				payMethod["method"] = "Payco";
			} else if (method === "MovenPay-Papara") {
				payMethod["method"] = "Papara";
			} else if (method === "SendToFriend") {
				if (languageCode === "en") {
					payMethod["method"] = "SendToFriend";
				} else if (languageCode === "tr") {
					payMethod["method"] = "Arkadaşına Gönder";
				} else {
					payMethod["method"] = "SendToFriend";
				}
			} else if (method === "BankTransfer") {
				if (languageCode === "en") {
					payMethod["method"] = "ATM Cardless Withdrawal";
				} else if (languageCode === "tr") {
					payMethod["method"] = "ATM Kartsız Çekim";
				} else {
					payMethod["method"] = "ATM Cardless Withdrawal";
				}
			} else if (method === "HizliPapara") {
				if (languageCode === "en") {
					payMethod["method"] = "Papara Fast";
				} else if (languageCode === "tr") {
					payMethod["method"] = "Papara Hızlı";
				} else {
					payMethod["method"] = "Papara Fast";
				}
			} else if (method === "MonetixFasterPayments" || method === "MonetixCardOut") {
				payMethod["logoCls"] = "w-60";
			} else if (method.indexOf("88Pay") > -1) {
				payMethod["logoCls"] = "no-filter";
			}
			resultArray.push(payMethod);
		}
		if (resultArray > 1) {
			resultArray.push({ method: "BankTransfer" });
		}
		return resultArray;
	}

	getPageContent() {
		const { currentPage, hoverItem } = this.state,
			{ loading, withdrawItems, isUnapprovedDocument, missingDocument, selectedCurrency } =
				this.props,
			layout = {
				wrapperCol: { span: 70 },
			};
		return (
			<Translate>
				{({ translate }) => (
					<div className="cube-form-wrapper">
						{isUnapprovedDocument ? (
							<div>
								{" "}
								{translate("MISSING_DOCUMENT", {
									missingDocument: missingDocument,
								})}{" "}
							</div>
						) : (
							<Fragment>
								<Loading loading={loading} />
								<Form
									{...layout}
									layout="vertical"
									name="basic"
									hideRequiredMark={true}
									initialValues={{ remember: true }}>
									<GRID_WRAPPER isSub={currentPage != 1}>
										{
											///////////////////
											//WITHDRAW SELECTION
											///////////////////
											currentPage === 1 &&
												this.getAllMethods(
													withdrawItems.filter(
														(item) => item.method !== "Penapay"
													)
												)
													.sort(this.sortMethods)
													.map((item, index) => {
														const methodCurrency =
															this.getCurrencyOfMethod(
																item.currencies
															);
														const currencyToUse =
															methodCurrency?.currency;
														return (
															<WithdrawItem
																key={`withdraw-key-${index}`}
																onMouseEnter={() =>
																	this.setHoverItem(item.method)
																}
																onMouseLeave={() =>
																	this.setHoverItem("")
																}>
																<WithdrawLogoWrapper>
																	<ImgWrapper>
																		<img
																			className={`bank-img ${item.logoCls}`}
																			src={this.getMethodLogo(
																				item.method
																			)}
																		/>
																	</ImgWrapper>
																	<WithdrawNameMobile
																		isHover={
																			hoverItem ===
																			item.method
																		}>
																		{this.formatWithdrawName(
																			item.name,
																			item.method
																		)}
																	</WithdrawNameMobile>
																</WithdrawLogoWrapper>
																<WithdrawContentWrapper>
																	{methodCurrency && (
																		<MinMaxWrapper>
																			{methodCurrency.withdraw &&
																				methodCurrency
																					.withdraw.max >
																					0 && (
																					<WithdrawMinMax>
																						<WithdrawValueWrapper>
																							<Value>
																								{formatMoney(
																									methodCurrency
																										.withdraw
																										.min,
																									currencyToUse
																								)}
																							</Value>
																							<MinOrMax>
																								{" "}
																								(MIN){" "}
																							</MinOrMax>
																						</WithdrawValueWrapper>
																						<WithdrawValueWrapper>
																							<Value>
																								{formatMoney(
																									methodCurrency
																										.withdraw
																										.max,
																									currencyToUse
																								)}
																							</Value>
																							<MinOrMax>
																								{" "}
																								(MAX){" "}
																							</MinOrMax>
																						</WithdrawValueWrapper>
																					</WithdrawMinMax>
																				)}
																		</MinMaxWrapper>
																	)}
																	<WithdrawNameWrapper>
																		<WithdrawNameDesktop
																			isHover={
																				hoverItem ===
																				item.method
																			}>
																			{this.formatWithdrawName(
																				item.name,
																				item.method
																			)}
																		</WithdrawNameDesktop>
																		<WithdrawNameFeaturesWrapper
																			isHover={
																				hoverItem ===
																				item.method
																			}></WithdrawNameFeaturesWrapper>
																	</WithdrawNameWrapper>
																</WithdrawContentWrapper>
																<WithdrawButton
																	isHover={
																		hoverItem === item.method
																	}
																	onClick={this.onSelectWithdraw.bind(
																		this,
																		item
																	)}>
																	<Icon>
																		<ArrowRight />
																	</Icon>
																	<Text>
																		{translate("SELECT")}
																	</Text>
																</WithdrawButton>
															</WithdrawItem>
														);
													})
										}
									</GRID_WRAPPER>
									<div>
										{
											//////////////
											//PAYMENT STEP
											//////////////
											currentPage != 1 && this.renderSelectedWithdraw()
										}
									</div>
								</Form>
							</Fragment>
						)}
					</div>
				)}
			</Translate>
		);
	}
}

const mapStateToProps = (state) => ({
	loading: state.withdraw.loading,
	isUnapprovedDocument: state.withdraw.hasUnapprovedDocument,
	missingDocument: state.withdraw.missingDocument,
	withdrawItems: state.withdraw.paymentMethods,
	wallet: state.balance.wallet,
	languages: state.localize.languages,
});

const mapDispatchToProps = {
	getDocumentStatus,
	getActiveWithdrawMethods,
	withdraw,
	showAlert,
	getUserInfo,
	getOdendibilTypes,
};

const WithVerificationWrapper = (Component) => {
	return (props) => {
		const { withVerification } = useVerification();
		return (
			<Component
				{...props}
				withVerification={withVerification}
			/>
		);
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(WithVerificationWrapper(Withdraw));
